import { format } from "date-fns";
import { parseApiDate } from "@gettactic/helpers/src/date-time/index";
import { toZonedTime } from "date-fns-tz";
import { cn } from "@gettactic/helpers";

export const isoToZonedDate = (isoDate: string, timeZone: string): Date => {
  return toZonedTime(isoDate, timeZone);
};

/** An API date as weekday and day number ("Wed 14"), in `tz` when given. */
export const DayDate = ({
  apiDate,
  tz,
  className,
  dateClassNAme,
  dayClassNameNAme
}: {
  apiDate: string;
  tz?: string;
  className?: string;
  dateClassNAme?: string;
  dayClassNameNAme?: string;
}) => {
  let date = parseApiDate(apiDate);
  if (tz) {
    date = isoToZonedDate(apiDate, tz);
  }
  return (
    <div className={cn("space-x-2", className)}>
      <Weekday className={dayClassNameNAme} date={date} />
      <DateNumber className={dateClassNAme} date={date} />
    </div>
  );
};

const Weekday = ({ date, className }: { date: Date; className?: string }) => {
  const day = format(date, "eee");
  return (
    <span
      className={cn("font-bold", className)}
      style={{ fontSize: "inherit" }}
    >
      {day}
    </span>
  );
};

const DateNumber = ({
  date,
  className
}: {
  date: Date;
  className?: string;
}) => {
  const day = format(date, "d");
  return (
    <span
      className={cn("font-[400] font-inter text-content text-sm", className)}
    >
      {day}
    </span>
  );
};
